import {Injectable} from '@angular/core';
import {SigningServiceHttp} from 'app/main/signing-pages/signing-service';


@Injectable({
  providedIn: 'root'
})
export class ForwardSignatureService {

  constructor(
      private http: SigningServiceHttp
    ) {
    }

    /**
     * invite to sign
     * @param role_id
     * @param document_id
     * @param data
     */
    forwardSignature(role_id:number, document_id:number ,data){
     return this.http.post(`sign-document/${role_id}/${document_id}/forward`, data);
    }
}
